import { AIAnalysisWidget } from "@features/ai-analysis/AIAnalysisWidget";
import { getChannelsFlat, useObjects } from "@features/devices/api";
import { PageLayoutWithHelp } from "@features/page-help";
import { useQueries } from "@tanstack/react-query";
import { Card, Col, Row, Space, Statistic, Typography } from "antd";
import { useMemo } from "react";
import { useNavigate } from "react-router";

const DashboardPage = () => {
  const navigate = useNavigate();
  const objectsQuery = useObjects();
  const objectsCount = objectsQuery.data?.length ?? 0;

  // Загружаем каналы для всех доступных объектов пользователя
  const uniqueObjects = useMemo(() => {
    if (!objectsQuery.data) return [];
    const seen = new Set<number>();
    return objectsQuery.data.filter((obj) => {
      if (seen.has(obj.n_ob)) return false;
      seen.add(obj.n_ob);
      return true;
    });
  }, [objectsQuery.data]);

  const channelQueries = useQueries({
    queries: uniqueObjects.map((obj) => ({
      queryKey: ["channels-flat", obj.n_ob, ""],
      queryFn: () => getChannelsFlat({ object: obj.n_ob, limit: 2000 }),
      enabled: !!objectsQuery.data,
    })),
  });

  const metersCount = useMemo(() => {
    return channelQueries.reduce((total, query) => {
      return total + (Array.isArray(query.data) ? query.data.length : 0);
    }, 0);
  }, [channelQueries]);

  const metersLoading = channelQueries.some((q) => q.isLoading);
  const metersError = channelQueries.some((q) => q.isError);

  const objectValue = useMemo(() => {
    if (objectsQuery.isLoading) {
      return "…";
    }
    if (objectsQuery.isError) {
      return "—";
    }
    return objectsCount;
  }, [objectsQuery.isLoading, objectsQuery.isError, objectsCount]);

  const meterValue = useMemo(() => {
    if (metersLoading) {
      return "…";
    }
    if (metersError) {
      return "—";
    }
    return metersCount;
  }, [metersLoading, metersError, metersCount]);

  return (
    <PageLayoutWithHelp title="Сводка">
      <Row gutter={[16, 16]} wrap>
        <Col xs={24} md={12} xl={6}>
          <Card hoverable onClick={() => navigate("/assets/objects")} style={{ cursor: "pointer" }}>
            <Space orientation="vertical" size={0} style={{ width: "100%" }}>
              <Typography.Text type="secondary">Объекты</Typography.Text>
              <Statistic value={objectValue} styles={{ content: { fontSize: 32 } }} />
              <Typography.Text type="secondary">
                все доступные объекты из /api/devices
              </Typography.Text>
            </Space>
          </Card>
        </Col>
        <Col xs={24} md={12} xl={6}>
          <Card hoverable onClick={() => navigate("/assets/devices")} style={{ cursor: "pointer" }}>
            <Space orientation="vertical" size={0} style={{ width: "100%" }}>
              <Typography.Text type="secondary">Счётчики</Typography.Text>
              <Statistic value={meterValue} styles={{ content: { fontSize: 32 } }} />
              <Typography.Text type="secondary">
                количество каналов /devices/channels
              </Typography.Text>
            </Space>
          </Card>
        </Col>
        <Col span={24}>
          <AIAnalysisWidget />
        </Col>
      </Row>
    </PageLayoutWithHelp>
  );
};

export default DashboardPage;
